<template>
  <div>
    <app-done description="Appointment has been added" />
  </div>
</template>

<script>
import ActionIsDone from "@/components/BookingApp/AdminView/New/ActionIsDone";

export default {
  name: "AppointmentAdded",
  components: {
    appDone: ActionIsDone,
  },
};
</script>

<style>
</style>